import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Toaster } from "react-hot-toast";
import { TrpcProvider } from "./providers/TrpcProvider";
import { AuthProvider } from "./providers/auth";
import KeyboardShortcutsProvider from "./components/KeyboardShortcutsProvider";
import theme from "./theme";
import routes from "./routes";

// AppRoutes component to use the routes configuration
const AppRoutes = () => {
  const routeElements = useRoutes(routes);
  return routeElements;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster position="top-right" />
      <TrpcProvider>
        <AuthProvider>
          <Router>
            <KeyboardShortcutsProvider>
              <AppRoutes />
            </KeyboardShortcutsProvider>
          </Router>
        </AuthProvider>
      </TrpcProvider>
    </ThemeProvider>
  );
}

export default App;
